import { Loader } from '@grafikr/components';

import { NonNullish } from 'utils/nullish-check';

export default Loader(({ node }, load) => {
  const searchParams = new URLSearchParams(window.location.search);
  const urlParam = NonNullish(node.dataset.loadUrlParam, 'has-url-param').split(':');

  const [key, value] = urlParam;

  if (searchParams.has(key)) {
    if (value) {
      if (searchParams.get(key) === value) {
        load();
      }
    } else {
      load();
    }
  }
});
